import * as i0 from '@angular/core';
import { Injectable, Component, ViewChild, NgModule } from '@angular/core';
import { map } from 'rxjs/internal/operators/map';
import * as i1 from '@angular/common/http';
import * as i6 from '@angular/forms';
import { NgForm } from '@angular/forms';
import { takeUntil, first } from 'rxjs/operators';
import * as i3 from 'dirty-check-store';
import { MarkDirtyFormAction, MarkCleanFormAction } from 'dirty-check-store';
import { Subject } from 'rxjs';
import * as i1$1 from 'primeng/dynamicdialog';
import * as i2 from '@ngrx/store';
import * as i4 from 'ngx-toastr';
import * as i7 from 'primeng/button';
import { PrimengLibraryModule } from 'primeng-library';

class NoteDialogComponentLibraryService {
    constructor(http) {
        this.http = http;
    }
    postNotifyBeneficiary(payload) {
        return this.http.post(`/notification/save`, payload).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
}
NoteDialogComponentLibraryService.ɵfac = function NoteDialogComponentLibraryService_Factory(t) { return new (t || NoteDialogComponentLibraryService)(i0.ɵɵinject(i1.HttpClient)); };
NoteDialogComponentLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: NoteDialogComponentLibraryService, factory: NoteDialogComponentLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NoteDialogComponentLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

class NoteDialogComponentLibraryComponent {
    constructor(dynamicDialogRef, store, dynamicDialogConfig, guard, toastService, noteDialogComponentLibraryService) {
        this.dynamicDialogRef = dynamicDialogRef;
        this.store = store;
        this.dynamicDialogConfig = dynamicDialogConfig;
        this.guard = guard;
        this.toastService = toastService;
        this.noteDialogComponentLibraryService = noteDialogComponentLibraryService;
        this.observableSubscription$ = new Subject();
        this.reason = '';
        this.title = '';
    }
    ngOnInit() {
        this.title = this.dynamicDialogConfig.data.title;
    }
    ngAfterViewInit() {
        this.noteDialogForm.form.valueChanges
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe(() => {
            if (this.noteDialogForm.dirty) {
                this.store.dispatch(new MarkDirtyFormAction({
                    dirty: true
                }));
            }
            else {
                this.store.dispatch(new MarkCleanFormAction({
                    dirty: false
                }));
            }
        });
    }
    handleSubmit() {
        this.dynamicDialogConfig.data.payload.title = this.title;
        this.dynamicDialogConfig.data.payload.text = this.reason;
        this.noteDialogComponentLibraryService.postNotifyBeneficiary(this.dynamicDialogConfig.data.payload)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response && response.status === 200) {
                this.toastService.success(response.message, 'Success');
                this.dynamicDialogRef.close();
            }
        });
    }
    handleClose() {
        // this.dynamicDialogRef.close();
        this.guard.canDeactivate().pipe(first()).subscribe((response) => {
            if (response) {
                this.dynamicDialogRef.close();
            }
            else {
                return false;
            }
        });
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
    }
}
NoteDialogComponentLibraryComponent.ɵfac = function NoteDialogComponentLibraryComponent_Factory(t) { return new (t || NoteDialogComponentLibraryComponent)(i0.ɵɵdirectiveInject(i1$1.DynamicDialogRef), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i1$1.DynamicDialogConfig), i0.ɵɵdirectiveInject(i3.DirtyFormGuard), i0.ɵɵdirectiveInject(i4.ToastrService), i0.ɵɵdirectiveInject(NoteDialogComponentLibraryService)); };
NoteDialogComponentLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: NoteDialogComponentLibraryComponent, selectors: [["lib-note-dialog-component"]], viewQuery: function NoteDialogComponentLibraryComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(NgForm, 1);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.noteDialogForm = _t.first);
    } }, decls: 16, vars: 2, consts: [["noteDialogForm", "ngForm"], [1, "col-md-12", "p-0", "row", "delete-header"], [1, "col-md-10", "p-0"], [1, "col-md-2", "p-0", "justify-content-end", "d-flex"], [1, "close-icon", "pi", "pi-times", 3, "click"], [1, "row", "col-md-12", "pl-0", "pb-3", "pt-3"], [1, "col-md-12", "row", "pl-0"], ["type", "text", 1, "im-input", "mw-100", 3, "ngModel", "ngModelChange"], [1, "row", "col-md-12", "pl-0", "justify-content-start", "d-flex", "pr-0"], [1, "col-md-3", "pl-0"], ["pButton", "", "type", "button", "label", "Submit", 3, "click"]], template: function NoteDialogComponentLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "form", null, 0);
        i0.ɵɵelementStart(2, "div", 1);
        i0.ɵɵelementStart(3, "div", 2);
        i0.ɵɵelementStart(4, "span");
        i0.ɵɵtext(5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 3);
        i0.ɵɵelementStart(7, "i", 4);
        i0.ɵɵlistener("click", function NoteDialogComponentLibraryComponent_Template_i_click_7_listener() { return ctx.handleClose(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 5);
        i0.ɵɵelementStart(9, "div", 6);
        i0.ɵɵtext(10, "Add Note");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "div", 6);
        i0.ɵɵelementStart(12, "input", 7);
        i0.ɵɵlistener("ngModelChange", function NoteDialogComponentLibraryComponent_Template_input_ngModelChange_12_listener($event) { return ctx.reason = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "div", 8);
        i0.ɵɵelementStart(14, "div", 9);
        i0.ɵɵelementStart(15, "button", 10);
        i0.ɵɵlistener("click", function NoteDialogComponentLibraryComponent_Template_button_click_15_listener() { return ctx.handleSubmit(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate(ctx.title);
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("ngModel", ctx.reason);
    } }, directives: [i6.ɵangular_packages_forms_forms_ba, i6.NgControlStatusGroup, i6.NgForm, i6.DefaultValueAccessor, i6.NgControlStatus, i6.NgModel, i7.ButtonDirective], styles: [".close-icon[_ngcontent-%COMP%]{color:#fff;background-color:#000;padding:10px;border-radius:20px;cursor:pointer;font-size:14px}.delete-header[_ngcontent-%COMP%]{color:#01a0da;border-bottom:1px dashed #707070;font-size:21px;font-weight:600;text-align:left;padding:35px 0 10px!important}.detele-body[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{padding:20px 0;margin-bottom:0;font-size:18px}.delete-buttons[_ngcontent-%COMP%]{border-top:1px dashed #707070;padding:20px 0 0!important;text-align:right}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NoteDialogComponentLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'lib-note-dialog-component',
                templateUrl: './note-dialog-component-library.component.html',
                styleUrls: ['./note-dialog-component-library.component.scss']
            }]
    }], function () { return [{ type: i1$1.DynamicDialogRef }, { type: i2.Store }, { type: i1$1.DynamicDialogConfig }, { type: i3.DirtyFormGuard }, { type: i4.ToastrService }, { type: NoteDialogComponentLibraryService }]; }, { noteDialogForm: [{
            type: ViewChild,
            args: [NgForm]
        }] }); })();

class NoteDialogComponentLibraryModule {
}
NoteDialogComponentLibraryModule.ɵfac = function NoteDialogComponentLibraryModule_Factory(t) { return new (t || NoteDialogComponentLibraryModule)(); };
NoteDialogComponentLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: NoteDialogComponentLibraryModule });
NoteDialogComponentLibraryModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(NoteDialogComponentLibraryModule, { declarations: [NoteDialogComponentLibraryComponent], imports: [PrimengLibraryModule], exports: [NoteDialogComponentLibraryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NoteDialogComponentLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [NoteDialogComponentLibraryComponent],
                imports: [
                    PrimengLibraryModule
                ],
                exports: [NoteDialogComponentLibraryComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of note-dialog-component-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NoteDialogComponentLibraryComponent, NoteDialogComponentLibraryModule, NoteDialogComponentLibraryService };
//# sourceMappingURL=note-dialog-component-library.js.map
